import React, { Fragment, useEffect, useState } from 'react';
import PageTitle from '../../components/pagetitle';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import { GET_MENUS_ALL_NESTED } from '../../constant/constants';
import Member from '../../components/Member';

const MemberPage = () => {
  const [profileId, setProfileId] = useState();

  useEffect(() => {
    fetch(`${GET_MENUS_ALL_NESTED}`)
      .then((response) => response.json())
      .then((data) => {
        data.menus.find((e) =>
          e.name === 'All Member' ? setProfileId(e.id) : null
        );
      })
      .catch(() => {});
  }, []);
  console.log('All Member', profileId);

  return (
    <Fragment>
      <PageTitle pageTitle={'Our All Member'} pagesub={'Our All Member'} />
      <Member id={profileId} />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default MemberPage;
